// Shared sanitizer for post-auth ?next= targets.
//
// An auth route is never a valid destination: sending a freshly signed-in user
// to /login or /signup just re-runs the same redirect against the session they
// now have, which is a loop. Off-origin targets are refused too, so ?next=
// cannot be used as an open redirect.
const AUTH_PATHS = new Set([
  '/login',
  '/signin',
  '/sign-in',
  '/log-in',
  '/logon',
  '/signup',
  '/register',
  '/sign-up',
  '/create-account',
  '/join',
  '/forgot-password',
  '/reset-password',
  '/reset',
]);

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.has((pathname || '/').replace(/\/$/, '') || '/');
}

export function safeNextPath(raw: string, fallback = ''): string {
  if (!raw) return fallback;
  if (typeof window === 'undefined') {
    const path = raw.split(/[?#]/)[0];
    return raw.startsWith('/') && !raw.startsWith('//') && !raw.startsWith('/\\') && !isAuthPath(path) ? raw : fallback;
  }
  let url: URL;
  try {
    url = new URL(raw, window.location.href);
  } catch {
    return fallback;
  }
  if (url.origin !== window.location.origin) return fallback;
  if (isAuthPath(url.pathname)) return fallback;
  return url.pathname + url.search + url.hash;
}
